import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTestimonialWidgetStyles = isSmallScreen => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    cardContainer: Object.assign({}, !isSmallScreen && {
      marginBottom: spacing.SPACING_44
    }),
    quotes: {
      lineHeight: spacing.SPACING_12,
      marginTop: spacing.SPACING_16
    },
    rightQuotes: {
      lineHeight: spacing.SPACING_30,
      marginTop: spacing.SPACING_18
    }
  });
};